import React, { useContext, useEffect, useState } from 'react';
// import { ConfigContext } from '../../../../lib/config/ConfigProvider';
import { QuantaConfigContext } from 'quanta-flows';

import {
  Modal,
  DataGridGroup,
  Text,
  useResponsiveParams,
} from 'quanta-ui';
// import CurrencyFormater from '../../../../lib/intl/CurrencyFormater'
import { CurrencyFormater } from 'quanta-flows';
// import useFetchQuery from '../../../../lib/graphql/useFetchQuery';
import { useFetchQuery } from 'quanta-flows';
// import { Loading } from '../../../../lib/layout';
import {Loading} from 'quanta-flows/modules/layout';
//SA975
require('dotenv').config();
const FOLLOW_API='Y';
// process.env.REACT_APP_FOLLOW_API;
//EA975
export default function ModalViewBreakupTW({
  showViewBreakup,
  setShowViewBreakup,
  productName,
  productType,
  productCode,
  lobCode,
  lobName,
  REACTIVE_VAR_QUERY,
  reactiveVarName,
  breakupData,
  premiumBreakupFor
}) {
  let repeatForMobile = 2;
  let repeatForDesktop = 3;
  let repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop,
  });
  const fetchQuery = useFetchQuery();
  const { branding } = useContext(QuantaConfigContext);
  const [reactiveVar, setReactiveVar] = useState(null);
  const [loadingBreakupDetails,setLoadingBreakupDetails] = useState(false);
  useEffect(() => {
    const getBreakupData = async () => {
      try {
        const reactiveVarQuery = fetchQuery({
          query: REACTIVE_VAR_QUERY,
        });
        setLoadingBreakupDetails(true);
        const { data } = await reactiveVarQuery;
        setLoadingBreakupDetails(false);
        setReactiveVar(data[`${reactiveVarName}`]);
      } catch (error) {
        setReactiveVar(null);
        setLoadingBreakupDetails(false);
      }
    };
    if (!breakupData && showViewBreakup) {
      getBreakupData();
    }
  }, [breakupData, REACTIVE_VAR_QUERY, reactiveVarName, reactiveVar, showViewBreakup]);
  //SA975  
  let discountArr = [];
    ((reactiveVar?.premiumData?.ncbamount!=='' && (reactiveVar?.premiumData?.ncbamount)!=='0' && (reactiveVar?.premiumData?.ncbamount)!==undefined)
    || (breakupData?.premiumData?.ncbamount!=='' && (breakupData?.premiumData?.ncbamount)!=='0' && (breakupData?.premiumData?.ncbamount)!==undefined))
    ?(discountArr.push({
      name:'No Claim Bonus',
      value:reactiveVar?.premiumData?.ncbamount
      || breakupData?.premiumData?.ncbamount,//value:Math.round(Number(reactiveVar?.premiumData?.ncbamount)) + '('+reactiveVar?.premiumData?.ncbpercentage+'%'+')',
    })):'';
    ((reactiveVar?.premiumData?.vddiscount_amt!=='' && reactiveVar?.premiumData?.vddiscount_amt!=='0' && reactiveVar?.premiumData?.vddiscount_amt!==undefined)
    || (breakupData?.premiumData?.vddiscount_amt!=='' && breakupData?.premiumData?.vddiscount_amt!=='0' && breakupData?.premiumData?.vddiscount_amt!==undefined))
    ?(discountArr.push({
      name:'Voluntary Excess Amount',
      value:reactiveVar?.premiumData?.vddiscount_amt
      || breakupData?.premiumData?.vddiscount_amt,
    })):'';
    let loadingArr = [];
    ((reactiveVar?.premiumData?.driving_tution_amount!=='' && (reactiveVar?.premiumData?.driving_tution_amount)!=='0' && (reactiveVar?.premiumData?.driving_tution_amount)!==undefined)
    || (breakupData?.premiumData?.driving_tution_amount!=='' && (breakupData?.premiumData?.driving_tution_amount)!=='0' && (breakupData?.premiumData?.driving_tution_amount)!==undefined))
    ?(loadingArr.push({
      name:'Driving Tution',
      value:reactiveVar?.premiumData?.driving_tution_amount
      || breakupData?.premiumData?.driving_tution_amount,
    })):'';
    ((reactiveVar?.premiumData?.fibre_glass_amount!=='' && reactiveVar?.premiumData?.fibre_glass_amount!=='0' && reactiveVar?.premiumData?.fibre_glass_amount!==undefined)
    || (breakupData?.premiumData?.fibre_glass_amount!=='' && breakupData?.premiumData?.fibre_glass_amount!=='0' && breakupData?.premiumData?.fibre_glass_amount!==undefined))
    ?(loadingArr.push({
      name:'Fibre Glass Fitted',
      value:reactiveVar?.premiumData?.fibre_glass_amount
      || breakupData?.premiumData?.fibre_glass_amount,
    })):'';
    
    //EA975
  const display_data = [
    {
      grid_data: [
        {
          colSpan: repeat,
          text: (
            <Text type="subheading" severity="info">
              {productName}
            </Text>
          ),
        },
      ],
    },
    {
      grid_data: [
        (reactiveVar?.productCode?.toString()==='3121'||
        reactiveVar?.productCode?.toString()==='3176'||
         reactiveVar?.productCode?.toString()==='3151'||
         reactiveVar?.productCode?.toString()==='3183'||
         reactiveVar?.productCode?.toString()==='3184'
         || productCode?.toString()==='3121'
         || productCode?.toString()==='3176'
         || productCode?.toString()==='3151'
         || productCode?.toString()==='3183'
         || productCode?.toString()==='3184')
        ?
        {
          label: 'Vehicle Details (Make, Model, Variant, Fuel Type,Cubic Capacity)',
          colSpan: repeat,
          text: (
            <Text>
              {[
                breakupData?.make?.value?.trim()
                  ? breakupData?.make?.value?.trim()
                  : reactiveVar
                  ? reactiveVar?.make?.value?.trim()
                  : '',
                breakupData?.model?.value?.trim()
                  ? breakupData?.model?.value?.trim()
                  : reactiveVar
                  ? reactiveVar?.model?.value?.trim()
                  : '',
                breakupData?.variant?.value?.trim()
                  ? breakupData?.variant?.value?.trim()
                  : reactiveVar
                  ? reactiveVar?.variant?.value?.trim()
                  : '',
                breakupData?.fuelType
                  ? breakupData?.fuelType
                  : reactiveVar
                  ? reactiveVar?.fuelType
                  : '',
                breakupData?.cubeCapacity
                  ? breakupData?.cubeCapacity
                  : reactiveVar
                  ? reactiveVar?.cubeCapacity
                  : '',
              ]
                .filter((a) => a)
                .join(', ')}
            </Text>
          ),
        }
        :
        {
          label: 'Vehicle Details (Make, Model, Variant, Fuel Type)',
          colSpan: repeat,
          text: (
            <Text>
              {[
                breakupData?.make?.value?.trim()
                  ? breakupData?.make?.value?.trim()
                  : reactiveVar
                  ? reactiveVar?.make?.value?.trim()
                  : '',
                breakupData?.model?.value?.trim()
                  ? breakupData?.model?.value?.trim()
                  : reactiveVar
                  ? reactiveVar?.model?.value?.trim()
                  : '',
                breakupData?.variant?.value?.trim()
                  ? breakupData?.variant?.value?.trim()
                  : reactiveVar
                  ? reactiveVar?.variant?.value?.trim()
                  : '',
                breakupData?.fuelType
                  ? breakupData?.fuelType
                  : reactiveVar
                  ? reactiveVar?.fuelType
                  : '',
              ]
                .filter((a) => a)
                .join(', ')}
            </Text>
          ),
        },
      ],
    },
    {
      grid_data: [
        {
          label: 'Date of registration & RTO Details',
          colSpan: repeat === repeatForMobile ? 2 : 2,
          text: (
            <Text>
              {[
                breakupData?.dateOfReg?.trim()
                  ? breakupData?.dateOfReg?.trim()
                  : reactiveVar
                  ? reactiveVar?.dateOfReg?.trim()
                  : '',
                breakupData?.rtoAuthorityCode?.trim()
                  ? breakupData?.rtoAuthorityCode?.trim()
                  : reactiveVar
                  ? reactiveVar?.rtoAuthorityCode?.trim()
                  : '',
                breakupData?.rtoLocationDesc
                  ? breakupData?.rtoLocationDesc?.trim()
                  : reactiveVar
                  ? reactiveVar?.rtoLocationDesc?.trim()
                  : '',
              ]
                .filter((a) => a)
                .join(', ')}
            </Text>
          ),
        },
        {
          label: <Text type="label">Tenure</Text>,
          text: (
            <Text type="normal">
              {breakupData ? (
                breakupData?.tenure ? (
                  `${breakupData?.tenure}${
                    breakupData?.tenure?.search(
                      'years',
                    ) === -1
                      ? ` year${
                          breakupData?.tenure === '1'
                            ? ''
                            : 's'
                        }`
                      : ''
                  }`
                ) : (
                  <Text className="text-neutral-darker">
                    Not Captured
                  </Text>
                )
              ) : reactiveVar ? (
                reactiveVar?.premiumData?.tenure ||
                reactiveVar?.tenure ? (
                  `${
                    reactiveVar?.premiumData?.tenure ||
                    reactiveVar?.tenure
                  }${
                    (
                      reactiveVar?.premiumData?.tenure ||
                      reactiveVar?.tenure
                    )?.search('years') === -1
                      ? ` year${
                          (reactiveVar?.premiumData?.tenure ||
                            reactiveVar?.tenure) === '1'
                            ? ''
                            : 's'
                        }`
                      : ''
                  }`
                ) : (
                  <Text className="text-neutral-darker">
                    Not Captured
                  </Text>
                )
              ) : null}
            </Text>
          ),
          colSpan: repeat === repeatForMobile ? 1 : 2,
        },
      ],
    },
    {
      grid_data: [
        {
          text: <Text type="normal">OD/TP Breakup</Text>,
          severity: 'info',
          colSpan: repeat === repeatForMobile ? 1 : 2,
        },
        {
          text: (
            <Text type="normal" className="flex justify-end mr-4">
              Premium ({branding?.currency})
            </Text>
          ),
          severity: 'info',
          colSpan: 1,
        },
        {
          text: <Text type="normal">Net OD Premium (After loading, discount and NCB)</Text>,
          severity: 'none',
          colSpan: repeat === repeatForMobile ? 1 : 2,
        },
        {
          text: (
            <Text type="normal" className="flex justify-end mr-4">
              {CurrencyFormater(
                breakupData
                  ? breakupData?.premiumData?.odpremium || breakupData?.premiumData?.netODPremium//SA975
                    ? Math.round(breakupData?.premiumData?.odpremium || breakupData?.premiumData?.netODPremium)//SA975
                    : 0
                  : reactiveVar
                  ? reactiveVar?.premiumData?.odpremium || reactiveVar?.premiumData?.netODPremium//SA975
                    ? Math.round(reactiveVar?.premiumData?.odpremium || reactiveVar?.premiumData?.netODPremium)//SA975
                    : 0
                  : 0,
                false,
                false,
                branding,
                true,
              )}
            </Text>
          ),
          severity: 'none',
          colSpan: 1,
        },
        {
          text: <Text type="normal">Net TP Premium</Text>,
          severity: 'none',
          colSpan: repeat === repeatForMobile ? 1 : 2,
        },
        {
          text: (
            <Text type="normal" className="flex justify-end mr-4">
              {CurrencyFormater(
                breakupData
                  ? breakupData?.premiumData?.net_tp_premiun || breakupData?.premiumData?.netTPPremium//SA975
                    ? Math.round(breakupData?.premiumData?.net_tp_premiun || breakupData?.premiumData?.netTPPremium)//SA975
                    : 0
                  : reactiveVar
                  ? reactiveVar?.premiumData?.net_tp_premiun || reactiveVar?.premiumData?.netTPPremium//SA975
                    ? Math.round(reactiveVar?.premiumData?.net_tp_premiun || reactiveVar?.premiumData?.netTPPremium)//SA975
                    : 0
                  : 0,
                false,
                false,
                branding,
                true,
              )}
            </Text>
          ),
          severity: 'none',
          colSpan: 1,
        },
      ],
    },
    //SA975
        {
          grid_data: (
            loadingArr.length>0
          )
            ? [
                {
                  text: <Text type="normal">Loadings</Text>,
                  severity: 'info',
                  colSpan: repeat === repeatForMobile ? 1 : 2,
                },
                {
                  text: (
                    <Text type="normal" className="flex justify-end mr-4">
                      {`Amount (${branding?.currency})`}
                    </Text>
                  ),
                  severity: 'info',
                  colSpan: 1,
                },
                ...(loadingArr?loadingArr.flatMap(
                  (loading, idx) => {
                          return [
                                      {
                                        text: `${loading?.name}`,
                                        colSpan: repeat === repeatForMobile ? 1 : 2,
                                        type: 'normal',
                                      },
                                      {
                                        text: (
                                          <Text className="flex justify-end mr-4">
                                            {CurrencyFormater(
                                              loading?.value,
                                              false,
                                              false,
                                              branding,
                                              true,
                                            )}
                                          </Text>
                                        ),
                                        colSpan: 1,
                                        type: 'normal',
                                      },
                                    ];
                                  },
                  ):
                  loadingArr?loadingArr.flatMap(
                    (loading, idx) => {
                                      return [
                                        {
                                          text: `${loading?.name}`,
                                          colSpan: repeat === repeatForMobile ? 1 : 2,
                                          type: 'normal',
                                        },
                                        {
                                          text: (
                                            <Text className="flex justify-end mr-4">
                                              {CurrencyFormater(
                                                loading?.value,
                                                false,
                                                false,
                                                branding,
                                                true,
                                              )}
                                            </Text>
                                          ),
                                          colSpan: 1,
                                          type: 'normal',
                                        },
                                      ];
                                    },
                ):''),
              ]
            : [
                {
                  text: <Text type="normal">Loading</Text>,
                  severity: 'info',
                  colSpan: repeat === repeatForMobile ? 1 : 2,
                },
                {
                  text: (
                    <Text type="normal" className="flex justify-end mr-4">
                      {CurrencyFormater(0, false, false, branding, true)}
                    </Text>
                  ),
                  severity: 'info',
                  colSpan: 1,
                },
              ],
        },
    {
      grid_data: (
        discountArr.length>0
      )
        ? [
            {
              text: <Text type="normal">Discounts</Text>,
              severity: 'info',
              colSpan: repeat === repeatForMobile ? 1 : 2,
            },
            {
              text: (
                <Text type="normal" className="flex justify-end mr-4">
                  {`Amount (${branding?.currency})`}
                </Text>
              ),
              severity: 'info',
              colSpan: 1,
            },
            ...(discountArr?discountArr.flatMap(
              (discount, idx) => {
                      return [
                                  {
                                    text: `${discount?.name}`,
                                    colSpan: repeat === repeatForMobile ? 1 : 2,
                                    type: 'normal',
                                  },
                                  {
                                    text: (
                                      <Text className="flex justify-end mr-4">
                                        {(discount?.name==='No Claim Bonus')||(reactiveVar?.productCode?.toString()==='3121'||
                          reactiveVar?.productCode?.toString()==='3176'||
                          reactiveVar?.productCode?.toString()==='3151'||
                          reactiveVar?.productCode?.toString()==='3183'||
                          reactiveVar?.productCode?.toString()==='3184')?
                                        (Math.round(parseFloat(discount?.value).toFixed(2)) +' ('+(reactiveVar?.premiumData?.ncbpercentage || breakupData?.premiumData?.ncbpercentage || reactiveVar?.premiumData?.NCB)+'%)'):
                                        (
                                        Math.round(parseFloat(discount?.value).toFixed(2))
                                        )}
                                      </Text>
                                    ),
                                    colSpan: 1,
                                    type: 'normal',
                                  },
                                ];
                              },
              ):
              discountArr?discountArr.flatMap(
                (discount, idx) => {
                                  return [
                                    {
                                      text: `${discount?.name}`,
                                      colSpan: repeat === repeatForMobile ? 1 : 2,
                                      type: 'normal',
                                    },
                                    {
                                      text: (
                                        <Text className="flex justify-end mr-4">
                                          {(discount?.name==='No Claim Bonus')?
                          (Math.round(parseFloat(discount?.value).toFixed(2) )+' ('+(reactiveVar?.premiumData?.ncbpercentage || breakupData?.premiumData?.ncbpercentage || reactiveVar?.NCB)+'%)'
                          ):(
                            Math.round(parseFloat(discount?.value).toFixed(2)))}
                                        </Text>
                                      ),
                                      colSpan: 1,
                                      type: 'normal',
                                    },
                                  ];
                                },
            ):''),
          ]
          :
          (breakupData
            ? breakupData?.premiumData &&
              (breakupData?.premiumData?.discount) &&
              (breakupData?.premiumData?.discount)!==undefined
            : reactiveVar &&
              reactiveVar.premiumData &&
              (reactiveVar.premiumData.discount) &&
              (reactiveVar.premiumData.discount)!==undefined )
        ? [
          {
            text: <Text type="normal">Discounts</Text>,
            severity: 'info',
            colSpan: repeat === repeatForMobile ? 1 : 2,
          },
          {
            text: (
              <Text type="normal" className="flex justify-end mr-4">
                {`Amount (${branding?.currency})`}
              </Text>
            ),
            severity: 'info',
            colSpan: 1,
          },
          ...(breakupData
            ? breakupData?.premiumData?.discount.flatMap(
                (discount, idx) => {
                  return [
                    {
                      text: `${discount?.name}`,
                      colSpan: repeat === repeatForMobile ? 1 : 2,
                      type: 'normal',
                    },
                    {
                      text: (
                        <Text className="flex justify-end mr-4">
                          {(discount?.name !== 'No Claim Bonus' && (productCode?.toString() == '3121' ||
                            productCode?.toString() == '3176' ||
                            productCode?.toString() == '3151')) ?
                              (Math.round(parseFloat(discount?.amount).toFixed(2)))
                            :(discount?.name === 'No Claim Bonus') || 
                            (productName.toLowerCase()?.search('liability') === -1) 
                              || (productCode?.toString() == '3121' ||
                              productCode?.toString() == '3176' ||
                              productCode?.toString() == '3151'||
                              productCode?.toString() == '3183'||
                              productCode?.toString() == '3184' ) 
                              // !=='Long Term Two Wheeler Secure - Liability Only' ?
                                ? breakupData?.premiumData?.NCB ?
                                  (`${Math.round(parseFloat(discount?.amount).toFixed(2))} (${breakupData?.premiumData?.NCB}%)`
                                      // ? ' (' + breakupData?.premiumData?.NCB + '%)' 
                                      // : ' (' + reactiveVar?.premiumData?.NCB + '%)'
                                  ) 
                                   :
                                   (`${Math.round((parseFloat(discount?.amount).toFixed(2)))}`)
                                
                            : (CurrencyFormater(
                              Math.round((parseFloat(discount?.amount).toFixed(2))),//discount?.amount,
                              false,
                              false,
                              branding,
                              true,
                            ))}
                        </Text>
                      ),
                      colSpan: 1,
                      type: 'normal',
                    },
                  ];
                },
              )
            : reactiveVar?.premiumData?.discount.flatMap(
                (discount) => {
                  
                  return [
                    {
                      text: `${discount?.name}`,
                      colSpan: repeat === repeatForMobile ? 1 : 2,
                      type: 'normal',
                    },
                    {
                      text: (
                        <Text className="flex justify-end mr-4">
                          {(discount?.name !== 'No Claim Bonus' && (reactiveVar?.productCode?.toString() == '3121' ||
                            reactiveVar?.productCode?.toString() == '3176' ||
                            reactiveVar?.productCode?.toString() == '3151'||
                            reactiveVar?.productCode?.toString()=='3183'||
                         reactiveVar?.productCode?.toString()=='3184')) ?
                            (parseFloat(discount?.amount).toFixed(2))
                            : (discount?.name === 'No Claim Bonus') || (reactiveVar?.productCode?.toString() == '3121' ||
                          reactiveVar?.productCode?.toString()=='3176'||
                          reactiveVar?.productCode?.toString()=='3151')?
                         ( productName?.toLowerCase()?.search('liability')  === -1 )||
                         (reactiveVar?.productCode?.toString()=='3121'||
                         reactiveVar?.productCode?.toString()=='3176'||
                         reactiveVar?.productCode?.toString()=='3151'||
                         reactiveVar?.productCode?.toString()=='3183'||
                         reactiveVar?.productCode?.toString()=='3184'
                          )
                          ?//'Long Term Two Wheeler Secure - Liability Only'?
                                (Math.round(parseFloat(discount?.amount).toFixed(2)) + ' (' + reactiveVar?.premiumData?.NCB + '%)'
                                ) : (Math.round(parseFloat(discount?.amount).toFixed(2)))
                                                    : (CurrencyFormater(
                           Math.round(parseFloat(discount?.amount).toFixed(2)),// discount?.amount,
                            false,
                            false,
                            branding,
                            true,
                          ))}
                        </Text>
                      ),
                      colSpan: 1,
                      type: 'normal',
                    },
                  ];
                },
              )),
          ]
          :[
            {
              text: <Text type="normal">Discount</Text>,
              severity: 'info',
              colSpan: repeat === repeatForMobile ? 1 : 2,
            },
            {
              text: (
                <Text type="normal" className="flex justify-end mr-4">
                  {CurrencyFormater(0, false, false, branding, true) }
                </Text>
              ),
              severity: 'info',
              colSpan: 1,
            },
          ],
          
    },
   
    {
      grid_data: [
        {
          text: <Text type="normal">NCB</Text>,
          severity: 'info',
          colSpan: repeat === repeatForMobile ? 1 : 2,
        },
        {
          text: (
            <Text type="normal" className="flex justify-end mr-4">
              {/* {CurrencyFormater( */}
               {  (breakupData?.premiumData?.NCB)//SA975
                    ?(breakupData?.premiumData?.NCB)//SA975
                  : (reactiveVar?.premiumData?.NCB)//SA975
                  ?(reactiveVar?.premiumData?.NCB)//SA975
                  : 0 }%
                {/* false,
                false,
                branding,
                true, */}
              {/* )} */}
            </Text>
          ),
          // severity: 'info',
          colSpan: 1,
        },],
      },
    //EA975
    {
      grid_data: [
        {
          text: <Text type="normal">Net Premium</Text>,
          severity: 'info',
          colSpan: repeat === repeatForMobile ? 1 : 2,
        },
        {
          text: (
            <Text type="normal" className="flex justify-end mr-4">
              {CurrencyFormater(
                breakupData
                  ? Math.round(breakupData?.premiumData?.premium || breakupData?.premiumData?.netPremium)//SA975
                    ? Math.round(breakupData?.premiumData?.premium || breakupData?.premiumData?.netPremium)//SA975
                    : 0
                  : Math.round(reactiveVar?.premiumData?.premium || reactiveVar?.premiumData?.netPremium)//SA975
                  ? Math.round(reactiveVar?.premiumData?.premium || reactiveVar?.premiumData?.netPremium)//SA975
                  : 0,
                false,
                false,
                branding,
                true,
              )}
            </Text>
          ),
          severity: 'info',
          colSpan: 1,
        },
        {
          text: <Text type="normal">{`GST/Tax`}</Text>,
          severity: 'info',
          colSpan: repeat === repeatForMobile ? 1 : 2,
        },
        {
          text: (
            <Text type="large" className="flex justify-end mr-4">
              {CurrencyFormater(
                breakupData
                  ? breakupData?.premiumData?.gst
                    ? Math.round(parseFloat(breakupData?.premiumData?.gst))
                    : 0
                  : reactiveVar?.premiumData?.gst
                  ? Math.round(parseFloat(reactiveVar?.premiumData?.gst))
                  : 0,
                false,
                false,
                branding,
                true,
              )}
            </Text>
          ),
          severity: 'info',
          colSpan: 1,
        },
        {
          text: <Text type="subheading">{`Total Premium`}</Text>,
          severity: 'info',
          colSpan: repeat === repeatForMobile ? 1 : 2,
        },
        {
          text: (
            <Text type="subheading" className="flex justify-end mr-4">
              {CurrencyFormater(
                breakupData
                  ? breakupData?.premiumData?.finalpremium || breakupData?.premiumData?.totalPremium//SA975
                    ? Math.round(parseFloat(
                        breakupData?.premiumData?.finalpremium || breakupData?.premiumData?.totalPremium,//SA975
                      ))
                    : 0
                  : reactiveVar?.premiumData?.finalpremium || reactiveVar?.premiumData?.totalPremium //SA975
                  ? Math.round(parseFloat(reactiveVar?.premiumData?.finalpremium || reactiveVar?.premiumData?.totalPremium))//SA975
                  : 0,
                false,
                false,
                branding,
                true,
              )}
            </Text>
          ),
          severity: 'info',
          colSpan: 1,
        },
      ],
    },
  ];

  return (
    <div className="text-black font-normal">
      <Modal
        display={showViewBreakup}
        size={repeat === repeatForMobile ? 'full' : 'small'}
        title={`Premium Breakup For ${premiumBreakupFor?premiumBreakupFor:'Quote'}`}
        className={repeat === repeatForMobile ? 'h-screen flex flex-col mt-16':''}
        onClose={(e) => setShowViewBreakup(false)}
        modalCloseDisabled={loadingBreakupDetails}
      >
        {loadingBreakupDetails && <Loading customMessage={'Fetching Breakup details'}/>}
        {!loadingBreakupDetails && <DataGridGroup
          data={display_data}
          textType="normal"
          severity="none"
          repeat={repeat}
          spaceY={4}
        />}
      </Modal>
    </div>
  );
}
